import React, { useEffect, useState } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import HomepageHero from '../homeHero';
import PixiManager from './pixi-manager';
import WindowExists from '../../utils/windowExists';

const HomeBackgroundContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: 50% 50%;
    @media (min-width: 1200px) and (max-height: 820px) {
        height: 920px;
    }
`;

const WebGlContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #303030;

    @media (min-width: 1200px) and (max-height: 820px) {
        height: 920px;
    }

    canvas {
        width: 100vw;
        height: 100vh;
        @media (min-width: 1200px) and (max-height: 820px) {
            height: 920px;
        }
    }
`;

const WrapperContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255,255,255,1);
    background-color: ${props => props.webGlLoaded && 'rgba(255,255,255,0)'};
    @media (min-width: 1200px) and (max-height: 820px) {
        height: 920px;
    }
`;

const WrapperCenter = styled.div`
    position: absolute;
    top: 55%;
    left: calc(50vw - 675px);
    @media (max-width: 1600px) {
        left: calc(50vw - 525px);
    }
    @media (max-width: 1200px) {
        left: 57px;
    }
    @media (max-width: 600px) {
        left: 15px;
    }
    transform: translateY(-50%);
    z-index: 5;
    color: #0064ba;
`;

const HomeBackgroundStatic = ({ children }) => (
    <HomeBackgroundContainer>
        <WrapperCenter>
            <HomepageHero />
        </WrapperCenter>
    </HomeBackgroundContainer>
);

const HomeBackground = ({
    children,
    webGlEnabled = false,
    renderRequest = () => {},
    langKey = 'en',
    data,
    title,
    paragraph
}) => {
    let webGlManager = null;
    const [webGlLoaded, setWebGlLoaded] = useState(false);
    useEffect(() => {
        async function loadWebGl() {
            if ( WindowExists() ) {
                // console.log('starting webgl');
                const pixi = await import('pixi.js');
                const filters = await import('@pixi/filter-displacement');
                const shock = await import('pixi-filters');
                webGlManager = new PixiManager(
                    pixi,
                    filters.DisplacementFilter,
                    shock.ShockwaveFilter,
                    data.markdownRemark.frontmatter.slider,
                    langKey
                );
                // WebGL Enabled :D
                webGlManager.start('canvas', () => {
                    setWebGlLoaded(true);
                });
            }
        }
        if (webGlEnabled && WindowExists()) {
            loadWebGl();
        }
        return () => {
            if ( webGlEnabled ) {
                setWebGlLoaded(false);
                webGlManager.del();
            }
        }
    }, []);

    return webGlEnabled && WindowExists()
        ? (
            <HomeBackgroundContainer>
                <WebGlContainer id="canvas" />
                <WrapperContainer webGlLoaded={webGlLoaded} >
                    <WrapperCenter className="wrapper-container">
                        <HomepageHero
                            webGlLoaded={webGlLoaded}
                            langKey={langKey}
                            heroText={title}
                            paragraph={paragraph}
                        />
                    </WrapperCenter>
                </WrapperContainer>
                {renderRequest()}
            </HomeBackgroundContainer>
        ) : <HomeBackgroundStatic>
            <HomepageHero />
        </HomeBackgroundStatic>;
};

export default function myHomeBackground(props) {
    return (<StaticQuery
            query={graphql`
                query {
                    markdownRemark(frontmatter: {templateKey: {eq: "index-page"}}) {
                        frontmatter {
                            slider {
                                language
                                title
                                title_kh
                                image
                            }
                        }
                    }
                }
            `}
        render={data => <HomeBackground data={data} {...props} />}
    />
    )
}